module.exports = "/_next/static/images/testimonial-image-min-84d2c8e7abbc59788549be141f125478.png";